import React from "react";
import { Sparkles } from "lucide-react";

/**
 * RecorderCommissionBanner — shows the active commission context above
 * the recorder. Pure presentational.
 *
 * Props:
 *   commission        — active commission doc or null/undefined (renders nothing when missing)
 *   lockUntil         — ISO string for the producer's lock-window expiry, or null
 */
export const RecorderCommissionBanner = ({ commission, lockUntil }) => {
  if (!commission) return null;
  const loc = commission.location?.city
    || commission.location?.country
    || `${commission.location?.lat?.toFixed?.(2)}, ${commission.location?.lng?.toFixed?.(2)}`;
  return (
    <div className="bg-amber-900/30 border border-amber-500/50 rounded-lg p-3" data-testid="commission-banner">
      <div className="flex items-start gap-2">
        <Sparkles className="h-4 w-4 text-amber-300 shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-amber-100 text-sm font-semibold">
            Filming a commission{commission.ec_username
              ? <> for <span className="text-amber-300">@{commission.ec_username}</span></>
              : " (anonymous Exec Producer)"}
          </p>
          <p className="text-amber-200/90 text-xs mt-0.5">
            &ldquo;{commission.title}&rdquo; — {loc}
          </p>
          <p className="text-amber-200/80 text-[11px] mt-1">
            Bounty <span className="font-semibold text-amber-200">+{Number(commission.bounty_credits || 0).toFixed(2)}</span> credits on publish ·
            {" "}{commission.max_duration_seconds || "?"}s · {commission.storage_days || "?"}d storage
            {commission.featured ? " · featured" : ""}
          </p>
          {lockUntil && (
            <p className="text-amber-300/70 text-[10px] mt-1" data-testid="commission-lock-until">
              Lock holds until {new Date(lockUntil).toLocaleTimeString()} — film &amp; publish before then.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
